import { createFileRoute } from "@tanstack/react-router";
import { listWorkflowEnrollments } from "api-client";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachWorkflowAthletesPage } from "src/pages/CoachWorkflowAthletesPage";

export const Route = createFileRoute(
  "/_auth/_coach/workflows/$workflowId/athletes",
)({
  component: RouteComponent,
  async loader({ params }) {
    return await loaderHandler(async () => {
      assert(params.workflowId, "No workflowId");

      const enrollmentsResponse = await listWorkflowEnrollments({
        path: {
          workflowId: params.workflowId,
        },
      });

      return {
        data: {
          enrollments: enrollmentsResponse.data.data,
        },
      };
    });
  },
});

function RouteComponent() {
  const { data } = Route.useLoaderData();
  return <CoachWorkflowAthletesPage enrollments={data.enrollments} />;
}
